import React from 'react';
import { css } from '@emotion/css';
import { ImageTabItem } from '../ImageInnerTabs';
import { Tab } from 'react-tabs';
import TabIndicator from '../TabIndicator';
import { silver_two, dark_sky_blue, ocean_blue, color_text_light, color_text_link } from '../../../constants/colors';
import TooltipWrapper from '../../general/TooltipWrapper';

interface ImageTabProps {
    tab: ImageTabItem
    index: number
    className?: string
}
function PrimaryIconTab(props: ImageTabProps) {
    return (
        <Tab key={props.index} selectedClassName={activeTabStyle} className={`${tabStyle} ${props.className ? props.className : ''} ${props.tab.className ?? ''}`}>
            <div className="tab-wrapper">
                <div className="tab-content">
                    <img className="tab-icon" src={props.tab.icon} />
                    <p>{props.tab.title}</p>
                </div>
            </div>
        </Tab>
    )
}

const tabStyle = css`
color: black;
cursor: pointer;
flex-grow: 1;
align-items: center;
margin: 0 4px;
min-width: 80px;
border-radius: 8px;
flex: 0;
.tab-wrapper {
    display: flex;
    align-items: center;
}
.tab-content {
    min-width: 48px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 56px;
    p {
        font-family: Muli;
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 16px;
        color: white;
    }
    img {
        width: 24px;
        height: auto;
    }
}
.tab-indicator {
    display: none;
    flex-grow: 0;
    flex-shrink: 0;
}
`;

const activeTabStyle = css`
background-color: ${color_text_link};

>.tab-indicator {
    display: block;
}
`;

export default PrimaryIconTab;